import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
}

export async function hallBookingBillDeleteApi(
	payload: RequestDataShape,
	token?: null | string,
) {
	const endpoint = "/hall/booking/bill/delete/v1"
	const requester = new ApiRequester<RequestDataShape, { success: boolean }>(endpoint)
	return await requester.sendRequest(payload, token)
}
